<template>
  <div>
     <div v-if="submit_loader" style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255, 255, 255, 0.31)">
          <div class="text-xs-center">
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="#ff9233"
                class="text-xs-center my-5"
                large
            ></v-progress-circular>
          </div>
      </div> 
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
          <!--   <v-flex xs12 class="text-xs-right" mt-1>
              <v-menu offset-y>
                <v-btn
                  slot="activator"
                  color="rgb(248 71 6)"
                  class="white--text list_notification"
                  @click="backtonotification()"
                >
                  <v-icon color="#bbbbc6" class="white--text mr-2"
                    >arrow_back</v-icon
                  >
                  back
                </v-btn>
              </v-menu>
            </v-flex> -->
            <v-form
              id="createStationAmenity"
              @submit.prevent="validateBeforeSubmit('createStationAmenity')"
              data-vv-scope="createStationAmenity"
              v-model="valid"
            >
              <v-card-text>
                <v-container
                  fluid
                  grid-list-md
                  style="padding: 0px 0px 0px 0px"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Station: </label>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <v-autocomplete
                        label="Select Station"
                        name="Station"
                        :items="local_stations"
                        v-model="station_amenity_object.station_id"
                        return-object
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('createStationAmenity.Station')
                        "
                        clearable
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Amenity: </label>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <v-autocomplete
                        label="Select Amenity"
                        name="Amenity_type"
                        :items="amenity_types"
                        v-model="station_amenity_object.amenity_type"
                        return-object
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('createStationAmenity.Amenity_type')
                        "
                        clearable
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Platform: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="platform"
                        v-model="station_amenity_object.platform"
                        clearable
                      ></v-text-field>
                     
                    </v-flex>
                  </v-layout>
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Description: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-textarea
                        name="Description"
                        v-model="station_amenity_object.description"
                        v-validate="'required'"
                        clearable
                      ></v-textarea>
                    </v-flex>
                  </v-layout> 
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Quantity: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="quantity"
                        v-model="station_amenity_object.quantity"
                        v-validate="'required'"
                        clearable
                      ></v-text-field>
                    </v-flex>
                  </v-layout>        
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="!valid" type="submit"
                  >create
                </v-btn>
                <v-btn flat small to="/station-amenities-list">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :color="snackBar.color"
        :top="snackBar.top"
        :bottom="snackBar.bottom"
        :left="snackBar.left"
        :right="snackBar.right"
        v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>



<script>
import moment from "moment";
import { VueEditor } from "vue2-editor";

export default {
  name: "Create",
  components: {
    VueEditor,
  },
  data: () => {
    return {
      station_amenity_object: {
        station_id: null,
        amenity_type: "",
        description: "",
        platform:"",
        quantity:"",
      },
      local_stations:[],
      amenity_types:[],
      status: true,
      submit_loader: false,
      valid: false,
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
    };
  },
 
  methods: {
  
    // backtonotification:function(){
    //     this.$router.push({name:"NotificationDetail"});
    // },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
    createStationAmenity: function () {
      this.submit_loader = true;
      let new_station_amenity = Object.assign({}, this.station_amenity_object);
      new_station_amenity.station_id = this.station_amenity_object.station_id.id;
      new_station_amenity.amenity_id = this.station_amenity_object.amenity_type.id;
      
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v1/store-station-amenity`,new_station_amenity,
           { headers: this.$headers }
        )
       
        .then((response) => {
          if (response.data.status == 1) {
            this.submit_loader = true;
            this.snackBar.show = true;
            this.snackBar.message = response.data.message;
            this.station_amenity_object = '';
      
          } else {
             
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.submit_loader = false;
        });
    },
    getStations: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/local-station`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
              
                this.local_stations = response.data.stations.local_stations;
                   
             }  
        })
    },
    getAmenityType: function(){
         axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/amenity`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                
                this.amenity_types = response.data.amenity_type;
                   
             }  
        })

    },
  },
   mounted(){
      this.getStations();
      this.getAmenityType();
  },
};
</script>

<style type="text/css">
  .accent--text {
    color: #f67656;
    caret-color: #383859;
}
</style>

